module.exports = __webpack_public_path__ + "img/lightning.83135885.svg";